module.exports = __webpack_public_path__ + "img/SISGEOMOVSALA11.5027cb0e.svg";